import { FEATURES } from '@constants/Text'
import { FINIA_EMBED_URL } from '@modules/finia/constants/URL'

// Perfil que opera a retaguarda financeira do escritório: gestor ou profissional
// com role `financeiro` (IS_FINANCIAL, derivado em @state/modules/user). Mesmo
// critério já usado pelo Faturamento em Tesouraria
// (@modules/tesouraria/constants/Text.js) e por additionalPermissions.treasury.
export const isFinancialOrManager = ({ user = {} } = {}) => {
  return !!(user.IS_GESTOR || user.IS_FINANCIAL)
}

// Gate único da Rotina Financeira (embed `finia`): destino configurado +
// funcionalidade do escritório + perfil. Consumido pelo item de menu
// (@constants/navigation-routes) e pelo guard da rota (customPermission em
// @modules/finia/routes) — um só critério evita o caso em que o menu esconde o
// módulo mas a URL direta continua abrindo.
//
// A checagem da URL é fail-closed: se o ambiente atual não tiver destino no
// mapa de @modules/finia/constants/URL, o módulo some do menu e a rota cai em
// 404, em vez de abrir um iframe apontando para lugar nenhum. Hoje os três
// ambientes têm URL, então a guarda é inerte; ela existe para o dia em que
// `homolog`/`prod` forem esvaziados à espera do deploy próprio.
export const canShowFiniaRoute = ({ user = {}, access = {} } = {}) => {
  return (
    !!FINIA_EMBED_URL &&
    isFinancialOrManager({ user }) &&
    !!access[FEATURES.PLATAFORMA_BPO_FINANCEIRO]
  )
}
